import loadable from '@loadable/component'

export const LanguageToggle = loadable(() => import('./LanguageToggle'))
export type { LanguageToggleProps } from './LanguageToggle'
